export const bonuses = [
  {
    label: 'Bono 1',
    title: '20 clases de detailing listas para dictar',
    body: 'Clases con objetivos, explicación, demostración, práctica y evaluación listas para adaptar.',
    highlight: 'Elegí → adaptá → enseñá',
  },
  {
    label: 'Bono 2',
    title: 'Atlas visual de diagnóstico y defectos',
    body: 'Recursos visuales para enseñar a reconocer defectos, contaminación, errores de pulido y problemas frecuentes.',
    highlight: 'Mirá → identificá → interpretá',
  },
  {
    label: 'Bono 3',
    title: '150 preguntas + modelos de evaluación',
    body: 'Creá evaluaciones diagnósticas, parciales y finales sin redactar cada pregunta desde cero.',
    highlight: 'Seleccioná → evaluá → reforzá',
  },
  {
    label: 'Bono 4',
    title: 'Kit de planillas del instructor',
    body: 'Organizá alumnos, asistencia, materiales, vehículos, prácticas, evaluaciones y resultados.',
    highlight: 'Registrá → organizá → controlá',
  },
  {
    label: 'Bono 5',
    title: '50 escenarios y desafíos prácticos',
    body: 'Casos para que tus alumnos observen, diagnostiquen, tomen decisiones y justifiquen sus respuestas.',
    highlight: 'Observar → analizar → decidir',
  },
];
